const isProduction = process.env.NODE_ENV === 'production';
const productionAPI = 'https://mg4.mdello.com';
const devAPI = 'https://mg4.mdello.com';
const devAPIM7 = 'https://m7.mdello.com';
// const devAPI = 'http://localhost:3000';

const API_URL = isProduction ? productionAPI : devAPI;
const API_URL_M7 = devAPIM7;

let cachedSessionId;

function setCachedSessionId(sessionId) {
  cachedSessionId = sessionId;
}

function getCachedSessionId() {
  return cachedSessionId;
}

module.exports = {
  API_URL,
  API_URL_M7,
  getCachedSessionId,
  isProduction,
  setCachedSessionId
};
